var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7259",
    "data-name": "Group 7259",
    transform: "translate(-404.5 -906.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(405 907)",
    fill: "#fff",
    stroke: "#40aeba",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(422.114 920.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path929",
    d: "M10.662,288.8a9.352,9.352,0,0,0-9.34,9.34c0,9.06,8.813,15.947,8.813,15.947a.849.849,0,0,0,1.059,0s8.813-6.887,8.813-15.947A9.358,9.358,0,0,0,10.662,288.8Zm0,1.7a7.633,7.633,0,0,1,7.648,7.641c0,7.411-6.711,13.267-7.641,14.06-.926-.789-7.648-6.646-7.648-14.06A7.627,7.627,0,0,1,10.662,290.5Z",
    transform: "translate(-1.322 -288.797)",
    fill: "#40aeba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle931",
    d: "M7.527,290.385A4.62,4.62,0,1,0,12.15,295,4.629,4.629,0,0,0,7.527,290.385Zm0,1.848A2.772,2.772,0,1,1,4.758,295,2.759,2.759,0,0,1,7.527,292.233Z",
    transform: "translate(1.813 -285.512)",
    fill: "#40aeba"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.0ad4f1beccca6aa6ec1f51f43fa5c01a.svg";
export { ForwardRef as ReactComponent };